export default __webpack_public_path__ + "static/media/map_final_emerald_archipelago.2f524505.jpg";